import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const AssetContext = React.createContext({});
export let appNavigatorMachine: any;

const MODULE_NAME = "machines.pageContent";
const log: any = LoggerModule?.getInstance();

export const useSMAppNavigator = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  appNavigatorMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(appNavigatorMachine);

  useEffect(() => {
    send({ type: "START" });
  }, []);

  return {
    appNavigatorMachine,
    appNavigatorState: state,
    appNavigatorSend: send,
  };
};
